module.exports = __webpack_public_path__ + "img/dfox-big.7fe9065e.png";